import React from "react";
import { Row, Col } from "react-bootstrap";

const Banner = () => {
  return (
    <div
      id="asesores-banner"
      className="bg-home d-flex align-items-md-center justify-content-md-center align-items-end"
      style={{
        background: `
          linear-gradient(180deg, rgba(4, 2, 29, 0) 0%, #04021D 80%),
          url('/images/advisors-banner.jpg')
        `,
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        minHeight: "clamp(50vh, 70vh, 145vh)",
        margin: 0,
        padding: 0,
      }}
    >
      <Row className="d-flex d-md align-items-center g-0 w-100">
        <Col md={12} className="ps-md-5 pe-md-0 px-5">
          <h1
            style={{
              fontFamily: "Libre Franklin, sans-serif",
              fontWeight: 800,
              fontSize: "clamp(2.5rem, 5vw, 5.25rem)",
              lineHeight: "1em",
              color: "#FFFFFF",
              position: "relative",
              zIndex: 2,
              marginTop: "23rem",
            }}
          >
            CONOCE A LOS ASESORES
            <wbr /> QUE TE AYUDAN A<wbr />{" "}
            <span className="t-700">TRANSPORTAR TU VEHÍCULO</span>
          </h1>
          <p
            style={{
              fontSize: "clamp(1rem, 2vw, 1.25rem)",
              lineHeight: "1.2em",
              fontWeight: "normal",
              color: "#FFFFFF",
              position: "relative",
              zIndex: 2,
              marginTop: "clamp(1rem, 1vw, 1.25rem)",
            }}
          >
            Asesores verificados, atención directa por WhatsApp
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default Banner;
